export const SET_FEATURES = 'at/features/SET_FEATURES'
export const UPDATE_FEATURES = 'at/features/UPDATE_FEATURES'



// WEBPACK FOOTER //
// ./web/js/features/actionTypes.js